import { atom } from "@mongez/react-atom";

export const contactUsAtom: any = atom({
  key: "successRequest",
  default: false,
});
